/* eslint-disable no-console */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useState, useEffect } from 'react';

import { Box, Button, makeStyles, Typography, Modal } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { arrayMoveImmutable } from 'array-move';

import MaterialsList from '../../components/observation/MaterialsList';
import SelectMaterials from '../../components/selectMaterials/SelectMaterials';

const useStyle = makeStyles(() => {
  return {
    addButton: {
      width: 102,
    },
    modalContent: {
      backgroundColor: 'white',
      borderRadius: '4px',
      left: '50%',
      maxHeight: '90vh',
      maxWidth: '90vw',
      outline: 'none',
      overflow: 'auto',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: '80%',
    },
    sectionContainer: {
      marginBottom: '32px',
      width: '100%',
    },
    sectionDescription: {
      color: '#999999',
      fontSize: '12px',
      marginBottom: 4,
      textAlign: 'left',
    },
    sectionHeader: {
      fontSize: '16px',
      fontWeight: '600',
    },
  };
});

const QuizMaterials = ({ isLoading, onMaterialsChange, initialMaterials = [] }) => {
  const classes = useStyle();
  const [materials, setMaterials] = useState(initialMaterials);
  const [selectMaterialsOpen, setSelectMaterialsOpen] = useState(false);

  useEffect(() => {
    setMaterials(initialMaterials);
  }, [initialMaterials]);

  useEffect(() => {
    if (onMaterialsChange) {
      onMaterialsChange(materials);
    }
  }, [materials, onMaterialsChange]);

  const handleOpenSelectMaterials = useCallback(() => {
    setSelectMaterialsOpen(true);
  }, []);

  const handleCloseSelectMaterials = useCallback(() => {
    setSelectMaterialsOpen(false);
  }, []);

  const handleSelectMaterials = useCallback(
    (selectedMaterials) => {
      try {
        handleCloseSelectMaterials();

        const materialsWithStructure = selectedMaterials.map((material, index) => ({
          id: material.id || Date.now() + index,
          material,
          materialId: material.id,
          order: index,
          resource: material.resource,
          title: material.title,
        }));

        setMaterials(materialsWithStructure);
      } catch (err) {
        console.error('Error processing selected materials:', err);
      }
    },
    [handleCloseSelectMaterials]
  );

  const handleDetachMaterial = useCallback((materialId) => {
    try {
      setMaterials((prev) =>
        prev.filter((material) => {
          const currentId = material.material?.id || material.materialId || material.id;
          return currentId !== materialId;
        })
      );
    } catch (err) {
      console.error('Error removing material:', err);
    }
  }, []);

  const handleMaterialSortEnd = useCallback(
    ({ oldIndex, newIndex }) => {
      if (oldIndex === newIndex) return;

      try {
        const newMaterials = arrayMoveImmutable(materials, oldIndex, newIndex);
        setMaterials(newMaterials);
      } catch (err) {
        console.error('Error updating material order:', err);
      }
    },
    [materials]
  );

  return (
    <>
      <div className={classes.sectionContainer}>
        <Box display="flex" flexDirection="row" gridGap={32} justifyContent="space-between" alignItems="flex-start">
          <Box display="flex" flexDirection="column" gridGap={4} alignItems="flex-start">
            <Typography className={classes.sectionHeader}>Educational Materials</Typography>
            <Typography className={classes.sectionDescription}>Add educational resources to your quiz collection.</Typography>
          </Box>

          <Button className={classes.addButton} variant="contained" color="primary" startIcon={<Add />} onClick={handleOpenSelectMaterials} disabled={isLoading}>
            Add
          </Button>
        </Box>

        {materials.length > 0 && (
          <Box mt={4}>
            <MaterialsList materials={materials} onRemove={handleDetachMaterial} sortable onSortEnd={handleMaterialSortEnd} />
          </Box>
        )}
      </div>

      <Modal open={selectMaterialsOpen} onClose={handleCloseSelectMaterials} aria-labelledby="select-materials-modal" aria-describedby="select-materials-for-quiz">
        <div className={classes.modalContent}>
          <SelectMaterials
            onSelectMaterials={handleSelectMaterials}
            onCloseViewer={handleCloseSelectMaterials}
            preSelectedMaterials={materials.map((m) => m.material || m).filter(Boolean)}
          />
        </div>
      </Modal>
    </>
  );
};

export default QuizMaterials;
